import { AnonymousConsentsEffects } from './anonymous-consents.effect';

export const effects: any[] = [AnonymousConsentsEffects];

export * from './anonymous-consents.effect';
